import styled from 'styled-components';

import hairBg from '../../assets/hair.svg';
import media from '../../styles/media.style';
import { BG_GRAY, BLACK, MOBILE_PADDING, PAGE_WIDTH, SCREEN_LOCKUP_WIDTH } from '../../styles/variables.style';

import checkBox from './checkbox.png';

export const Section = styled.section`
  padding: 30px ${MOBILE_PADDING}px 40px;
  // background: center / cover no-repeat url(${hairBg}), ${BG_GRAY.COMMON_1};
  margin: auto;
  max-width: ${PAGE_WIDTH}px;
  width: 100%;

  ${media.tabletL`
    padding: 100px 0;
  `};
`;

export const SectionLabel = styled.div`
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.9px;
  margin: 80px auto 50px;
  position: relative;
  text-align: center;

  ${media.tabletL`
    font-size: 18px;
    letter-spacing: 0.7px;
    margin: 80px auto 85px;
  `};

  &::after {
    background-color: black;
    bottom: -25px;
    content: '';
    height: 2px;
    left: calc(50% - 20px);
    position: absolute;
    width: 40px;
  }
`;

export const Inner = styled.div`
  margin: auto;
  max-width: ${SCREEN_LOCKUP_WIDTH}px;
  width: 100%;
`;

export const InnerInput = styled.div`
  margin: auto;
  max-width: ${SCREEN_LOCKUP_WIDTH}px;
  width: 100%;
  display: ${({ page }) => (page === 'input' ? 'block' : 'none')};
`;

export const InnerConfirm = styled.div`
  margin: auto;
  max-width: ${SCREEN_LOCKUP_WIDTH}px;
  width: 100%;
  display: ${({ page }) => (page === 'confirm' ? 'block' : 'none')};

  > dl {
    ${media.tabletL`
      // border-top: 1px solid ${BLACK};
    `};
    dt {
      ${media.tabletL`
        // border-bottom: 1px solid ${BLACK};
        padding-top: 30px;
        padding-bottom: 30px;
      `};
    }
    dd {
      ${media.tabletL`
        // border-bottom: 1px solid ${BLACK};
        margin-bottom: 0;
        padding-top: 30px;
        padding-bottom: 30px;
      `};
    }
  }
  > dl.lines {
    ${media.tabletL`
      border-top: 0;
    `};
    hr {
      display: none;
      ${media.tabletL`
        display: block;
      `};
    }
    dt {
      margin-bottom: 25px;
      ${media.tabletL`
        padding-top: 30px;
        padding-bottom: 30px;
      `};
    }
    dd {
      margin-bottom: 30px;
      div {
        margin-top: 15px;
        margin-bottom: 0;
        ${media.tabletL`
          margin-top: 0;
        `};
      }
      .line-items {
        margin-top: 0;
        ${media.tabletL`
          margin-bottom: 40px;
        `};
      }
    }
  }
`;

export const InnerThanks = styled.div`
  margin: auto;
  max-width: ${SCREEN_LOCKUP_WIDTH}px;
  width: 100%;
  display: ${({ page }) => (page === 'thanks' ? 'block' : 'none')};
`;

export const InnerError = styled.div`
  margin: auto;
  max-width: ${SCREEN_LOCKUP_WIDTH}px;
  width: 100%;
  display: ${({ page }) => (page === 'error' ? 'block' : 'none')};
`;

export const Form = styled.form`
  display: block;
`;

export const Dl = styled.dl`
  margin-bottom: 40px;
  ${media.tabletL`
    display: flex;
    flex-wrap: wrap;
  `};
`;

export const Dt = styled.dt`
  display: block;
  font-size: 16px;
  ${media.tabletL`
    width: 25%;
    padding-top: 10px;
  `};
`;

export const Dd = styled.dd`
  display: block;
  margin-inline-start: 0;
  margin-bottom: 25px;
  ${media.tabletL`
    width: 75%;
  `};
`;

export const Required = styled.span`
  color: #f00;
  margin-left: 5px;
`;

export const Error = styled.div`
  font-size: 12px;
  color: #f00;
  margin-top: 10px;
  display: ${({ error }) => (error ? 'block' : 'none')};
  ${media.tabletL`
    font-size: 14px;
  `};
`;

export const Input = styled.input`
  border: none;
  color: #000;
  // flex-grow: 1;
  font-family: FuturaStd;
  font-size: 12px;
  outline: none;
  border-bottom: 2px solid #000;
  display: block;
  width: 100%;
  padding: 10px 10px 10px 0;
  ::placeholder {
    color: #ccc;
    ${media.tabletL`
      font-size: 14px;
    `};
  }
  ${media.tabletL`
    font-size: 18px;
  `};
`;

export const Label = styled.label`
  display: flex;
`;

export const CheckboxIcon = styled.span`
  display: inline-block;
  width: 20px;
  height: 20px;
  background-image: url(${checkBox});
  background-size: 20px 40px;
  margin-right: 5px;
`;

export const Checkbox = styled.input`
  display: none;
  &:checked {
    + ${CheckboxIcon} {
      background-position: 0 20px;
    }
  }
`;

export const SelectWrap = styled.div`
  position: relative;
  // display: inline-block;
  &::after {
    content: '';
    position: absolute;
    top: 47%;
    right: 25px;
    transform: translateY(-50%) rotate(${({ open }) => (open ? '-45deg' : '135deg')});
    transform-origin: 10px 6px;
    width: 10px;
    height: 10px;
    border-top: 2px solid ${BLACK};
    border-right: 2px solid ${BLACK};
    transition: transform 0.3s;
    pointer-events: none;
  }
`;

export const Select = styled.select`
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border: none;
  color: #000;
  font-family: FuturaStd;
  font-size: 12px;
  outline: none;
  border-bottom: 2px solid #000;
  background-color: transparent;
  padding: 10px 50px 10px 0;
  border-radius: 0;
  display: block;
  width: 100%;
  &::-ms-expand {
    display: none;
  }
  ${media.tabletL`
    font-size: 18px;
  `};
`;

export const Option = styled.option``;

export const ButtonContainer = styled.div`
  text-align: center;
`;

export const Button = styled.input`
  border-radius: 0;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border: 0;
  background-color: #000;
  color: #fff;
  line-height: 1;
  padding: 20px;
  margin-bottom: 20px;
  min-width: 300px;
  display: inline-block;
  text-align: center;
  cursor: pointer;
  margin-left: 10px;
  margin-right: 10px;
`;

export const ButtonLink = styled.a`
  border: 0;
  background-color: #000;
  color: #fff;
  line-height: 1;
  padding: 20px;
  min-width: 300px;
  display: inline-block;
  text-align: center;
  cursor: pointer;
  &:hover {
    color: #fff;
  }
`;

export const Hr = styled.hr`
  height: 1px;
  background-color: #000;
  border: 0;
  margin-bottom: 30px;
`;

export const Title = styled.div`
  font-size: 26px;
  font-weight: 600;
  line-height: 1.15;
  letter-spacing: 0.6px;
  text-align: center;
  margin-bottom: 30px;

  ${media.tabletL`
    margin-bottom: 40px;
    font-size: 48px;
    font-weight: 500;
    line-height: 1;
  `};
`;

export const Description = styled.div`
  font-size: 12px;
  line-height: 1.5;
  letter-spacing: 0.1px;
  margin: 0 auto 40px;
  // max-width: 600px;
  ${media.tabletL`
    font-size: 14px;
    margin-bottom: 80px;
    text-align: center;
  `};
`;

export const LineTitle = styled.div`
  margin-bottom: 20px;
  margin-top: 30px;
  ${media.tabletL`
    margin-top: 40px;
    &:nth-child(1) {
      margin-top: 10px;
    }
  `};
`;

export const LineList = styled.div`
  display: block;
`;

export const LineItem = styled.div`
  display: block;
  width: 100%;
  margin-bottom: 20px;
  ${media.tabletL`
    display: inline-block;
    width: 50%;
  `};
`;

export const LineItems = styled.div`
  display: block;
  margin-bottom: 20px;
`;



// WEBPACK FOOTER //
// ./src/pages/SalonInfoUpdatePage/SalonInfoUpdatePage.style.js